import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LevelYearSetService } from '../level-year-set.service';

export function levelYearUnsetGuard(redirectUrl: string[]): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const levelYearSetService: LevelYearSetService =
      inject(LevelYearSetService);

    return levelYearSetService.levelYearSetCheck().pipe(
      map((value) => {
        if (value) {
          return router.createUrlTree(redirectUrl);
        }

        return true;
      }),
    );
  };
}
